import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { GetBy } from '../_app/cuchillo/core/Element';
import ScrollItem__Default from './ScrollItem__Default';
import { Maths } from '../_app/cuchillo/utils/Maths';

class ScrollItem__GalleryCircle extends ScrollItem__Default {
  
  lines = [];
  total = 0;
  tick = 0;

  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this.setupLines();

    this.onMove = () => {
      this.loop();
    };
  }

  setupLines() {
    const temp = GetBy.class("__line", this.item);
    this.total = temp.length;
    const angleStep = 360 / this.total; 

    for (let i = 0; i < this.total; i++) {
      const angle = i * angleStep;
      this.lines.push(new ScrollItem__GalleryCircle__Lines(temp[i], i, angle));
    }
  }

  loop() {
    const progress = this.progress;  // Aquí usas el progreso
    this.updateRotation(progress);
  }

  updateRotation(progress) {
    // Convertir el progreso (que va de 0 a 1, pero puede ir más allá) en un ángulo
    const rotationAngle = progress * 360;  // Puedes ajustar el factor multiplicador si lo prefieres más rápido o más lento.

    this.lines.forEach((line, i) => {
      const angle = (i * (360 / this.total)) + rotationAngle;
      line.setPosition(angle, progress);
    });
  }
}

class ScrollItem__GalleryCircle__Lines {
  index;
  figure;
  img;
  scale;

  constructor(dom, index, grados) {
    this.index = index;
    this.figure = GetBy.selector("figure", dom)[0];
    this.img = GetBy.selector("img", dom)[0];

    this.scale = {
      scale0: Maths.maxminRandom(12, 8) / 10,
      scale1: Maths.maxminRandom(12, 8) / 10
    };

    this.dom = dom;
    this.setPosition(grados);
  }

  setPosition(grados, progress) {
    const radius = 100; // Ajustar según sea necesario
    const x = radius * Math.cos((grados * Math.PI) / 180);
    const y = radius * Math.sin((grados * Math.PI) / 180);

    // Calcular la escala dinámica basada en el progreso
    const scaleValue = this.scale.scale0 + (this.scale.scale1 - this.scale.scale0) * Math.abs(Math.sin(progress * Math.PI));

    this.dom.style.transform = `translate(${x}px, ${y}px) rotate(${grados}deg) scale(${scaleValue})`;

    // Invertir la rotación del figure para mantenerlo recto
    if (this.figure) {
      this.figure.style.transform = `rotate(${-grados}deg)`;
    }
  }
}

Scroll._registerClass('gallery-circle', ScrollItem__GalleryCircle);
